import { NFTextInput } from "../../../../Shared/NewForms/NFTextInput";
import { Col, Row } from "react-bootstrap";
import { NFDateInput } from "../../../../Shared/NewForms/NFDateInput";
import { NFLookupCompany } from "../../../../Shared/NewForms/NFLookupCompany";
import { NFLookupCurrency } from "../../../../Shared/NewForms/NFlookupCurrency";
import { NFLookupInput } from "../../../../Shared/NewForms/NFLookupInput";
import { NFLookupCashflowItem } from "../../../../Shared/NewForms/NFLookupCashflowItem";
import { EnumHelper } from "../../../../../helpers/EnumHelper";
import { NFLookupDivision } from "../../../../Shared/NewForms/NFLookupDivision";
import { NFLookupPaymentRequests } from "../../../../Shared/NewForms/NFLookupPaymentRequests";
import { NFLookupCashRegister } from "../../../../Shared/NewForms/NFLookupCashRegister";
import { useTranslation } from "react-i18next";
import { NFLookupVendorCustomer } from "../../../../Shared/NewForms/NFLookupVendorCustomer";
import { NFLookupContract } from "../../../../Shared/NewForms/NFLookupContract";
import { useFormContext } from "react-hook-form";

const IncomingCashsVendorRefundDetail = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext();

  return (
    <Row>
      <Col sm={6}>
        <NFLookupVendorCustomer fieldName="vendorCustomerId" title={t("VendorsAndCustomers")} required />
      </Col>
      <Col sm={6}>
        <NFLookupContract fieldName="contractId" title={t("Contract")} required />
      </Col>
    </Row>
  );
};

export default IncomingCashsVendorRefundDetail;
